// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.schedule.scheduleitem.recurrence.RecurPatternWeeklyResponse */
/* istanbul ignore next */
@GandalfModel
export class RecurPatternWeeklyResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	weeklyAmount!: number | null;

	@GandalfProperty({ designType: Boolean })
	weeklyFriday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklyMonday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklySaturday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklySunday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklyThursday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklyTuesday!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	weeklyWednesday!: boolean | null;

}
